module.exports = __webpack_public_path__ + "static/media/lake_profile.eaba5f14.jpg";